"use client";
import React from "react";
import { Provider } from "react-redux";
import { store } from "@/src/store/store";
import PropTypes from "prop-types";

const Providers = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};

Providers.propTypes = {
  children: PropTypes.node,
};

export default Providers;
